import axios from "axios";
import CookieKeys from "../model/constants/cookieKeys";
import router from "../router";
import mainStore from "../store/store";
import { logout as sessionLogout, getAuthToken } from "./session";

function setLoader(val){
  mainStore.dispatch("setLoader",val);
}

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API,
  timeout: 100000 // request timeout
});
// request interceptor
service.interceptors.request.use(
  config => {
    let token = localStorage.getItem(CookieKeys.AUTH_KEY);
    config.headers["authorization"] = `Bearer ${token}`;
    setLoader(true);
    return config;
  },
  error => {
    setLoader(false);
    Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  response => {
    setLoader(false);
    return response
  },
  error => {
    setLoader(false);
    if (!error.response)
    {
      return Promise.reject(new Error("Service Unavailable"))
    }
    if (401 === error.response.status) {
      const url = (error.config && error.config.url) || ''
      // Token yoksa (giriş sayfası vb.) oturum kapatma/yönlendirme yapma: aksi halde sonsuz yenileme döngüsü olur.
      if (!url.includes('SelfService/session-events') && getAuthToken()) {
        // Oturum sunucuda geçersiz (süresi doldu, kullanıcı silindi/pasif, şube kapandı, çıkış yapıldı):
        // tarayıcıdaki oturumu da tamamen kapat ki geri tuşuyla sayfalar açılmasın. Kasadaki sepet korunur.
        const current = router.currentRoute ? router.currentRoute.fullPath : null
        sessionLogout({ notifyServer: false, keepCart: true, redirectTo: current })
      }
    }

    return Promise.reject(error);
  }
);

export default service;
